// Core-ticketportal yerine core'dan aktarılıyor.
import Events from '/../core/views/pages/events';
export default Events;